export default {
  defaultImage: 'https://via.placeholder.com/100/100',
  errorColor: '#e91818',
};
